import React from "react";
// import AvcilarSidebar from "../components/ServiceRegions/Sidebar/AvcilarSidebar";
// import BakirkoySidebar from "../components/ServiceRegions/Sidebar/BakirkoySidebar";
// import BahcelievlerSidebar from "../components/ServiceRegions/Sidebar/BahcelievlerSidebar";
// import BagcilarSidebar from "../components/ServiceRegions/Sidebar/BagcilarSidebar";
// import BasaksehirSidebar from "../components/ServiceRegions/Sidebar/BasaksehirSidebar";
// import BayrampasaSidebar from "../components/ServiceRegions/Sidebar/BayrampasaSidebar";
import BesiktasSidebar from "../components/ServiceRegions/Sidebar/BesiktasSidebar";
// import BeylikduzuSidebar from "../components/ServiceRegions/Sidebar/BeylikduzuSidebar";
// import BeyogluSidebar from "../components/ServiceRegions/Sidebar/BeyogluSidebar";
// import BuyukcekmeceSidebar from "../components/ServiceRegions/Sidebar/BuyukcekmeceSidebar";
// import EsenlerSidebar from "../components/ServiceRegions/Sidebar/EsenlerSidebar";
// import EsenyurtSidebar from "../components/ServiceRegions/Sidebar/EsenyurtSidebar";
// import EyupsultanSidebar from "../components/ServiceRegions/Sidebar/EyupsultanSidebar";
// import FatihSidebar from "../components/ServiceRegions/Sidebar/FatihSidebar";
// import GungorenSidebar from "../components/ServiceRegions/Sidebar/GungorenSidebar";
// import KagithaneSidebar from "../components/ServiceRegions/Sidebar/KagithaneSidebar";
import KucukcekmeceSidebar from "../components/ServiceRegions/Sidebar/KucukcekmeceSidebar";
import SariyerSidebar from "../components/ServiceRegions/Sidebar/SariyerSidebar";
// import SultangaziSidebar from "../components/ServiceRegions/Sidebar/SultangaziSidebar";
// import SisliSidebar from "../components/ServiceRegions/Sidebar/SisliSidebar";
// import ZeytinburnuSidebar from "../components/ServiceRegions/Sidebar/ZeytinburnuSidebar";
import FAQBox from "./FAQBox";

const AllServiceRegions = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <div className="text-sm text-gray-600 mb-4">
        <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; Hizmet Bölgeleri
      </div>

      <h1 className="text-3xl text-center font-bold text-[#003132] mb-6">HİZMET BÖLGELERİ</h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="space-y-6">
          <KucukcekmeceSidebar />
          <BesiktasSidebar />
        </div>

        <div className="md:col-span-2 space-y-8">
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#003132]">📍 Küçükçekmece Halı ve Koltuk Yıkama Hizmeti</h2>
            <p>
              İstanbul'nın modern yüzü Küçükçekmece’de, temizlik hizmetlerine olan ihtiyaç her geçen gün artıyor.
             İstanbul Temizlik Servisi olarak Küçükçekmece'nin her mahallesine profesyonel hizmet sunuyoruz.
              Halı, koltuk, perde ve yorgan gibi ev tekstil ürünlerinizi yerinde veya fabrikamızda özenle temizliyoruz.
            </p>
            <p className="font-semibold">Sunduğumuz Hizmetler:</p>
            <ul className="list-disc list-inside">
              <li>Koltuk Yıkama</li>
              <li>Halı Yıkama</li>
              <li>Yerinde Halı Yıkama</li>
              <li>Stor ve Zebra Perde Yıkama</li>
              <li>Yorgan, Battaniye Yıkama</li>
            </ul>
            <p>
              Özellikle Batıkent, Demetevler, Ergazi, Ata gibi bölgelerde hızlı servisimiz bulunmaktadır.
              Lekelerden, kötü kokulardan ve mikrop birikiminden tamamen kurtulmak için bize güvenebilirsiniz!
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#003132]">📍 Sincan Halı ve Koltuk Yıkama Hizmeti</h2>
            <p>
              Sincan’ın geniş konut projeleri ve yoğun yerleşimi, temizlik hizmetlerinde profesyonel çözümleri zorunlu kılıyor.
             İstanbul Temizlik Servisi olarak Sincan genelinde ev ve ofisler için tam kapsamlı yıkama hizmetleri sunuyoruz.
            </p>
            <p className="font-semibold">Sunduğumuz Hizmetler:</p>
            <ul className="list-disc list-inside">
              <li>Koltuk Yıkama</li>
              <li>Halı Yıkama</li>
              <li>Yerinde Halı ve Koltuk Yıkama</li>
              <li>Stor, Zebra, Tül Perde Yıkama</li>
              <li>Yorgan, Battaniye ve Yastık Yıkama</li>
            </ul>
            <p>
              Fatih, Osmanlı, Malazgirt, Yenikent gibi tüm mahallelere aynı gün içerisinde hizmet veriyoruz.
              Koltuklarınızı yerinden kıpırdatmadan profesyonel makinelerimizle temizliyoruz!
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#003132]">📍 Etimesgut Halı ve Koltuk Yıkama Hizmeti</h2>
            <p>
              Etimesgut, yeni yapılan konut projeleri ve site yaşamıyla modern İstanbul'nın parlayan bölgelerinden biridir.
              Hijyenik yaşam alanları için profesyonel yıkama şart!
            </p>
            <p>
             İstanbul Temizlik Servisi olarak Etimesgut ilçesinde;
            </p>
            <ul className="list-disc list-inside">
              <li>Koltuk Yıkama</li>
              <li>Halı Yıkama</li>
              <li>Yerinde Halı Yıkama</li>
              <li>Stor ve Zebra Perde Yıkama</li>
              <li>Yorgan ve Battaniye Yıkama</li>
            </ul>
            <p>
              Eryaman, Elvankent, Göksu, Yapracık gibi semtlere hızlı servis imkanı sağlıyoruz.
              İnatçı lekeler, toz akarları ve kötü kokulara kesin çözüm üretiyoruz.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#003132]">📍 Mamak Halı ve Koltuk Yıkama Hizmeti</h2>
            <p>
              Mamak ilçesi, eski ve yeni yapıların bir arada olduğu, yoğun nüfuslu bölgelerden biridir.
             İstanbul Temizlik Servisi olarak, Mamak’ta koltuklarınızı ve halılarınızı tertemiz hale getiriyoruz.
            </p>
            <p className="font-semibold">Sunduğumuz Hizmetler:</p>
            <ul className="list-disc list-inside">
              <li>Koltuk Yıkama</li>
              <li>Halı Yıkama</li>
              <li>Yerinde Halı ve Koltuk Yıkama</li>
              <li>Stor, Zebra, Tül Perde Yıkama</li>
              <li>Yorgan, Battaniye Yıkama</li>
            </ul>
            <p>
              Natoyolu, Abidinpaşa, Mutlu Mahallesi, General Zeki Doğan bölgelerine özel hızlı servis sağlıyoruz.
              İster yerinde, ister fabrikamızda özenle temizlik yapıyoruz!
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#003132]">📍 Çankaya Halı ve Koltuk Yıkama Hizmeti</h2>
            <p>
              İstanbul’nın en prestijli ilçesi olan Çankaya’da, yaşam kalitesi yüksek olduğu kadar temizlik beklentileri de yüksektir.
             İstanbul Temizlik Servisi olarak Çankaya genelinde üst düzey temizlik hizmetleri sunuyoruz.
            </p>
            <p className="font-semibold">Sunduğumuz Hizmetler:</p>
            <ul className="list-disc list-inside">
              <li>Koltuk Yıkama</li>
              <li>Halı Yıkama</li>
              <li>Yerinde Halı Yıkama</li>
              <li>Stor ve Zebra Perde Yıkama</li>
              <li>Yorgan ve Battaniye Yıkama</li>
            </ul>
            <p>
              Bahçelievler, Gaziosmanpaşa, Tunalı Hilmi, Çiğdem Mahallesi gibi semtlere hızlı servis sağlıyoruz.
              Özel kumaşlar ve hassas döşemeler için ayrı temizlik teknikleri kullanıyoruz.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#003132]">📍 Keçiören Halı ve Koltuk Yıkama Hizmeti</h2>
            <p>
              Keçiören, İstanbul'nın en büyük ve en yoğun nüfuslu ilçelerinden biridir.
              Bu yoğunluk, halı ve koltuk gibi ev tekstil ürünlerinin daha sık profesyonel temizlik gerektirmesine neden olur.
            </p>
            <p>
             İstanbul Temizlik Servisi olarak Keçiören’in her mahallesine;
            </p>
            <ul className="list-disc list-inside">
              <li>Koltuk Yıkama</li>
              <li>Halı Yıkama</li>
              <li>Yerinde Halı Yıkama</li>
              <li>Stor ve Zebra Perde Yıkama</li>
              <li>Yorgan ve Battaniye Yıkama</li>
            </ul>
            <p>
              Etlik, Kalaba, Bağlum, Yayla ve Kanuni gibi tüm semtlere hızlı ve etkili hizmet götürüyoruz.
              Koltuklarınızı ve halılarınızı mikrop ve toz akarlarından arındırıyoruz.
            </p>
          </div>
        </div>

        <div className="space-y-6">
          <KucukcekmeceSidebar />
          <SariyerSidebar />
          <FAQBox />
        </div>
      </div>
    </div>
  );
};

export default AllServiceRegions;
